import React from "react";
import Seo from "@/components/Seo";

const Privacy = () => {
  return (
    <>
      <Seo
        title="Privacy Policy"
        description="How Calmbreeze (West London commercial HVAC specialists) collects, uses, and protects your personal data — UK GDPR compliant."
        path="/privacy"
      />
      <section className="pt-[160px] pb-20 max-w-3xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="font-mono text-[11px] tracking-overline uppercase text-accent mb-6">[ Privacy Policy ]</div>
        <h1 className="font-display font-bold text-[2.5rem] md:text-[3.5rem] leading-[0.98] tracking-tightest mb-10">
          Privacy Policy
        </h1>
        <p className="text-[13px] text-muted-foreground mb-12">Last updated: January 2026.</p>

        <div className="prose-editorial">
          <h2>1. Who we are</h2>
          <p>
            Coles HVAC Services Ltd, trading as Calmbreeze (&ldquo;Calmbreeze&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;), is the data controller for this website.
            Coles HVAC Services Ltd is registered in England &amp; Wales under company number 11814249, with registered office at 14 Hyde Lodge, 11 Pennyroyal Drive, West Drayton, UB7 9FF, United Kingdom.
            You can reach us at <a href="mailto:Hello@calmbreeze.co.uk">Hello@calmbreeze.co.uk</a> or 01895 919 333.
          </p>

          <h2>2. What we collect</h2>
          <ul>
            <li>Name, email, phone, company and message via the contact form.</li>
            <li>The pain points, sector and contact details you enter into the Compliance Health Check.</li>
            <li>Email address if you subscribe to our monthly compliance digest.</li>
            <li>Basic technical information (browser type, device, IP address) needed to keep the site secure.</li>
          </ul>

          <h2>3. Why we collect it</h2>
          <p>
            We only use your information to respond to your enquiry, deliver the service you have requested,
            send you the newsletter you have subscribed to, and meet our legal obligations.
          </p>

          <h2>4. Lawful basis</h2>
          <p>
            We process your data on the basis of (a) your <strong>consent</strong> (newsletter, optional cookies),
            (b) the <strong>performance of a contract</strong> (responding to a quote request), and
            (c) our <strong>legitimate interest</strong> in running and securing the website.
          </p>

          <h2>5. Who we share data with</h2>
          <p>We use a small number of trusted processors to operate the site:</p>
          <ul>
            <li><strong>Resend</strong> — transactional email delivery.</li>
            <li><strong>MongoDB Atlas</strong> — encrypted database hosting (EU region).</li>
            <li><strong>Emergent</strong> — application hosting platform.</li>
          </ul>
          <p>We do not sell your data and we never share it with marketing networks.</p>

          <h2>6. How long we keep it</h2>
          <p>
            Contact and booking submissions are kept for up to 3 years. Newsletter subscriptions are kept until you
            unsubscribe. Health Check responses are kept for 12 months.
          </p>

          <h2>7. Your rights</h2>
          <p>
            Under UK GDPR you have the right to access, correct, delete, restrict or object to our processing of
            your personal data, and to data portability. To exercise any of these rights, email{" "}
            <a href="mailto:Hello@calmbreeze.co.uk">Hello@calmbreeze.co.uk</a>. You also have the right to complain to
            the Information Commissioner&rsquo;s Office (ico.org.uk).
          </p>

          <h2>8. Cookies</h2>
          <p>
            See our <a href="/cookies">Cookies Policy</a> for a full breakdown of the cookies we use and how to manage them.
          </p>

          <h2>9. Security</h2>
          <p>
            Submissions are sent over HTTPS, stored encrypted at rest, and we apply strict security headers
            (HSTS, X-Content-Type-Options, X-Frame-Options, Referrer-Policy, Permissions-Policy) to protect this site.
          </p>

          <h2>10. Changes</h2>
          <p>
            We may update this policy from time to time. The most recent version will always live at calmbreeze.co.uk/privacy.
          </p>
        </div>
      </section>
    </>
  );
};

export default Privacy;
